/**
 * Compute the redirect target for an unauthenticated user landing on a
 * protected page.
 *
 * The user's ask: "When a link is provided, it should ask the user
 * clicking the link to login first, then direct the user to the linked
 * page once they are logged in." — LoginPage already handles the
 * "direct back" half via its `?next=` query param; this helper is the
 * "preserve the intended URL" half.
 *
 * Isolated in a standalone module (no react-router import) so it stays
 * unit-testable via plain Jest without pulling in the router.
 *
 * @param {string} dest  `location.pathname + location.search`
 * @returns {string}     path to Navigate to
 */
export function computeLoginRedirectTarget(dest) {
  // Skip the ?next= dance if the user is already sitting at /login
  // (would be a no-op loop) or at the landing page (no useful
  // destination to preserve — LoginPage picks the role-based landing
  // path anyway).
  const skip = dest === "/" || dest === "/login" || dest.startsWith("/login?");
  return skip ? "/login" : `/login?next=${encodeURIComponent(dest)}`;
}
